/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Delete_Account_TitleInputs */

const es_user_profile_delete_account_title = /** @type {(inputs: User_Profile_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta`)
};

const en_user_profile_delete_account_title = /** @type {(inputs: User_Profile_Delete_Account_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete account`)
};

/**
* | output |
* | --- |
* | "Delete account" |
*
* @param {User_Profile_Delete_Account_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_delete_account_title = /** @type {((inputs?: User_Profile_Delete_Account_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Delete_Account_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_delete_account_title(inputs)
	return en_user_profile_delete_account_title(inputs)
});
export { user_profile_delete_account_title as "user.profile.delete_account.title" }